import React, { FC } from "react";

import wash1 from "../assets/images/lavageAlAmen.png";
import wash2 from "../assets/images/souessi.jpeg";
import wash3 from "../assets/images/lavageMuni.png";

type WashingStation = {
  image: string;
  alt: string;
  title: string;
  description: string;
};

const washingStations: WashingStation[] = [
  {
    image: wash2,
    alt: "Souassi Sfax",
    title: "Lavage Orient",
description:
  "Située à Souassi (Sfax), cette station offre un service de lavage rapide, efficace et adapté aux besoins quotidiens des véhicules.",
  },
  {
    image: wash3,
    alt: "Station Industrielle",
    title: "Lavage de la municipalité de Djebeniana",
    description:  "Située à Djebeniana, cette station de lavage professionnel propose un service moderne, rapide et adapté à tous types de véhicules.",

  },
  {
    image: wash1,
    alt: "Station Al Amen",
    title: "Lavage Al Amen",
    description:  "Lavage Al Amen propose un service d’entretien automobile fiable et soigné, adapté à tous types de véhicules.",

  },

];

const WashingCard: FC<{ station: WashingStation }> = ({ station }) => (
  <div className="group flex w-full sm:max-w-sm md:max-w-md flex-col overflow-hidden rounded-2xl bg-white border border-gray-100 shadow-md hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">

    <div className="relative h-52 sm:h-56 md:h-64 w-full overflow-hidden bg-gray-100">
      <img
        src={station.image}
        alt={station.alt}
        className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
      />

      {/* overlay hover */}
      <div className="absolute inset-0 bg-gradient-to-t from-blue-900/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
    </div>

    <div className="flex flex-1 flex-col p-6">

      {/* accent line (comme NosStations) */}
      <div className="mb-3 h-1 w-10 rounded-full bg-yellow-400 group-hover:w-16 transition-all duration-300"></div>

      <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">
        {station.title}
      </h3>

      <p className="text-gray-600 text-xs sm:text-sm leading-relaxed flex-1">
        {station.description}
      </p>

    </div>
  </div>
);

const LavageProfessionnel: FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">

      {/* HERO (style identique NosStations) */}
      <div className="relative bg-gradient-to-br from-blue-700 via-blue-700 to-blue-900 pt-28 sm:pt-32 md:pt-40 pb-16 sm:pb-20 md:pb-28 px-4 sm:px-6 text-center overflow-hidden">

        <div className="relative z-10 max-w-3xl mx-auto">

          <span className="inline-flex items-center gap-2 text-yellow-400 text-xs font-bold tracking-[0.25em] uppercase mb-4">
            <span className="w-8 h-px bg-yellow-400"></span>
            Service professionnel
            <span className="w-8 h-px bg-yellow-400"></span>
          </span>

          <h1 className="text-3xl sm:text-4xl md:text-5xl xl:text-6xl font-black text-white mb-6">
            Lavage Professionnel
          </h1>

          <p className="text-blue-100/90 text-sm sm:text-base md:text-lg leading-relaxed px-2">
            Découvrez nos stations de lavage professionnel équipées pour garantir un nettoyage rapide, efficace et de haute qualité.
          </p>

        </div>
      </div>

      {/* SECTION */}
      <div className="px-4 sm:px-6 pb-16">

        <section className="pt-16">

          {/* header section style identique NosStations */}
          <div className="flex flex-col items-center mb-10">
            <span className="text-yellow-500 text-xs font-bold tracking-[0.2em] uppercase mb-2">
              Nos solutions
            </span>
            <div className="mt-4 h-1.5 w-16 rounded-full bg-gradient-to-r from-blue-600 to-yellow-400"></div>
          </div>

          {/* GRID */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 justify-items-center">

            {washingStations.map((station) => (
              <WashingCard
                key={station.title}
                station={station}
              />
            ))}

          </div>

        </section>

      </div>
    </div>
  );
};

export default LavageProfessionnel;